<app-header
  [navbarBrandRouterLink]="['/dashboard']"
  [fixed]="true"
  [navbarBrandFull]="{src: 'assets/img/logo.jpeg', width: 120, height: 40, alt: 'SSBK'}"
  [navbarBrandMinimized]="{src: 'assets/img/logo-sm.png', width: 32, height: 41, alt: 'SSBK'}"
  [sidebarToggler]="'lg'"
  [asideMenuToggler]="''" [asideMenuToggler]=false
[mobileAsideMenuToggler]=false>

  <ul class="nav navbar-nav ml-auto">

    <li class="nav-item dropdown" dropdown placement="bottom right">
      <a class="nav-link" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false" dropdownToggle >
        <i class="icon-user icons font-2xl"></i>
      </a>
      <div class="dropdown-menu dropdown-menu-right" *dropdownMenu aria-labelledby="simple-dropdown">
        <div class="dropdown-header text-center"><strong>Account</strong></div>

        <a class="dropdown-item" href="#"><i class="fa fa-user"></i> Profile</a>
     <div class="divider"></div>

        <a class="dropdown-item" [routerLink]="" (click)="logout()"><i class="fa fa-lock"></i> Logout</a>
      </div>
    </li>
  </ul>
</app-header>
<div class="app-body">
  <app-sidebar #appSidebar [fixed]="true" [display]="'lg'" [minimized]="sidebarMinimized" (minimizedChange)="toggleMinimize($event)">
    <app-sidebar-nav [navItems]="navItems" [perfectScrollbar] [disabled]="appSidebar.minimized"></app-sidebar-nav>
    <app-sidebar-minimizer></app-sidebar-minimizer>
  </app-sidebar>

  <main class="main">
 <div class="container-fluid p-0">
     <div class="row mb-4 bg-white border-bottom">
     <div class="col-md-6">
    <cui-breadcrumb>

    </cui-breadcrumb>
          </div>
          <div class="col-md-6">
         <app-navbtn></app-navbtn>
         </div>


         </div>
     </div>

    <div class="container-fluid">
      <router-outlet></router-outlet>
    </div><!-- /.container-fluid -->
  </main>

</div>
<app-footer class="justify-content-center">
  <span>&copy; 2020  <a href="#">Shirdi Sai Biksha Kendra(SSBK)</a> .</span>

</app-footer>
